<template>
  <div>
    <div v-if="calcCanShow" class="esiaWrap">
      <p>Одобряем до 98% заявок при оформлении займа через Госуслуги</p>
      <button v-on:click="gotoEsia" class="instButton">
        <svg width="260" height="40" viewBox="0 0 260 40" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><rect x="1" y="1" width="258" height="38" rx="9" stroke="#0065B4" stroke-width="2"/><path d="M236 12l-1.41 1.41 5.58 5.59H228v2h12.17l-5.58 5.59L236 28l8-8-8-8z" fill="#1466AC"/><path d="M107.391 24.916h-2.609a.128.128 0 01-.127-.162c.436-1.425.891-3.037 1.205-4.825a40.45 40.45 0 00.563-5.073.13.13 0 01.133-.122h7.754a.13.13 0 01.132.127v9.928a.13.13 0 01-.132.127h-2.541a.13.13 0 01-.132-.127v-7.668h-2.551a31.272 31.272 0 01-.511 3.631 34.516 34.516 0 01-1.06 4.078.13.13 0 01-.124.086z" fill="#EE2F53"/><path d="M53 14.861c0-.07.06-.127.132-.127h7.492c.093 0 .157.093.12.176l-.928 2.134a.13.13 0 01-.133.076l-.014.001h-3.864v7.668a.13.13 0 01-.132.127h-2.54A.13.13 0 0153 24.79v-9.928z" fill="#0066B3"/><path d="M128.293 14.861a.13.13 0 01.132-.127h7.491c.094 0 .157.093.121.176l-.928 2.134a.129.129 0 01-.133.076l-.014.001h-3.864v7.668a.13.13 0 01-.133.127h-2.54a.13.13 0 01-.132-.127v-9.928zM83.32 14.734c-.092 0-.155.087-.124.169l3.86 10.015a123.237 123.237 0 01-1.842 3.544c-.045.085.018.187.117.187h2.746c.05 0 .096-.028.119-.07 2.032-3.968 3.527-7.484 5.572-13.677a.129.129 0 00-.126-.168h-2.55a.133.133 0 00-.128.094c-.787 2.647-1.513 4.72-2.354 6.716l-2.593-6.727a.132.132 0 00-.124-.083H83.32zM116.161 14.734c-.092 0-.155.087-.124.169l3.86 10.015a121.963 121.963 0 01-1.842 3.544c-.045.085.018.187.117.187h2.746c.05 0 .096-.028.119-.07 2.032-3.968 3.527-7.484 5.572-13.677.028-.082-.036-.168-.125-.168h-2.551a.133.133 0 00-.128.094c-.787 2.647-1.513 4.72-2.354 6.716l-2.593-6.727a.132.132 0 00-.124-.083h-2.573zM102.692 22.513a.141.141 0 00-.074-.075.158.158 0 00-.107-.005c-.61.215-1.752.391-2.548.391-1.741 0-2.57-.449-2.57-3 0-2.04.254-3.001 2.57-3.001.657 0 1.266.09 2.041.306a.139.139 0 00.16-.065 54.39 54.39 0 001.032-1.932.13.13 0 00.003-.11.143.143 0 00-.087-.076 11.904 11.904 0 00-3.33-.492c-3.648 0-5.273 1.644-5.273 5.332 0 3.74 1.625 5.409 5.273 5.409.914 0 2.715-.183 3.585-.514.068-.028.105-.103.079-.168l-.754-2z" fill="#EE2F53"/><path d="M81.347 22.513a.14.14 0 00-.073-.075.16.16 0 00-.108-.005c-.609.215-1.751.391-2.547.391-1.741 0-2.571-.449-2.571-3 0-2.04.254-3.001 2.57-3.001.657 0 1.267.09 2.041.306a.14.14 0 00.16-.065c.29-.52.639-1.154 1.033-1.932a.125.125 0 00.002-.11.14.14 0 00-.086-.076 11.904 11.904 0 00-3.33-.492c-3.648 0-5.274 1.644-5.274 5.332 0 3.74 1.626 5.409 5.274 5.409.913 0 2.715-.183 3.584-.514.069-.028.105-.103.08-.168l-.755-2zM66.327 14.454c-3.566 0-4.955 1.495-4.955 5.331 0 3.895 1.389 5.41 4.955 5.41 3.595 0 4.996-1.515 4.996-5.41 0-3.836-1.401-5.33-4.996-5.33zm0 8.506c-1.625 0-2.131-.432-2.131-3.137 0-2.88.553-3.136 2.13-3.136 1.61 0 2.173.257 2.173 3.136 0 2.705-.516 3.137-2.172 3.137z" fill="#0066B3"/><path d="M146.553 14.734h-2.539a.129.129 0 00-.133.127v7.672c-.55.147-1.1.217-1.719.217-1.54 0-1.986-.415-2.044-2.148v-5.74a.129.129 0 00-.133-.128h-2.539a.129.129 0 00-.133.127v.015s0 5.774.004 5.782c.06 3.26 1.293 4.537 4.337 4.537 1.778 0 3.762-.433 4.939-.863a.129.129 0 00.089-.125v-9.346c.003-.07-.055-.127-.129-.127z" fill="#EE2F53"/><path d="M40.733 16.293c-.1-1.288-1.1-2.94-2.101-3.733a38.266 38.266 0 00-3.502-2.246 39.156 39.156 0 00-3.702-1.916A5.46 5.46 0 0029.293 8a5.345 5.345 0 00-2.134.397 39.394 39.394 0 00-3.703 1.916c-1.934 1.156-3.502 2.246-3.502 2.246a6.122 6.122 0 00-1.479 1.802c-.293.54.146 1.138.762 1.138.677 0 1.28-.392 1.721-.906.187-.217.394-.42.619-.605 0 0 1.294-.894 2.891-1.842.99-.577 2.01-1.101 3.057-1.571a4.44 4.44 0 011.762-.325c.604-.01 1.204.1 1.763.325a32.41 32.41 0 013.057 1.571 31.614 31.614 0 012.891 1.842c.826.65 1.653 2.005 1.735 3.061 0 0 .193 1.571.22 3.432a31.64 31.64 0 01-.192 3.44 4.992 4.992 0 01-1.763 3.062s-1.294.92-2.891 1.869c-.99.576-2.01 1.101-3.057 1.571a4.44 4.44 0 01-1.763.325 4.534 4.534 0 01-1.762-.317 32.41 32.41 0 01-3.057-1.571c-1.597-.921-2.891-1.87-2.891-1.87a4.124 4.124 0 01-.601-.594c-.431-.516-1.03-.897-1.703-.897-.628 0-1.064.613-.754 1.16.398.703.917 1.346 1.435 1.757 0 0 1.568 1.156 3.502 2.28a39.137 39.137 0 003.703 1.915 5.46 5.46 0 002.134.387 5.345 5.345 0 002.135-.397 39.398 39.398 0 003.702-1.916 56.508 56.508 0 003.502-2.28 6.098 6.098 0 002.135-3.732A38.82 38.82 0 0041 20.479c-.033-2.27-.267-4.186-.267-4.186z" fill="url(#paint0_linear_259_4217)"/><path d="M18 17.991c0-.276.224-.5.501-.5h7.765c.277 0 .5.224.5.5v1.503c0 .277-.223.501-.5.501H18v-2.004z" fill="#0066B3"/><path d="M18 21.497h15.78c.277 0 .501.224.501.501v1.503c0 .277-.224.501-.5.501H18.5a.501.501 0 01-.501-.5v-2.005z" fill="#EE2F53"/><defs><linearGradient id="paint0_linear_259_4217" x1="29.5" y1="8" x2="29.5" y2="33" gradientUnits="userSpaceOnUse"><stop stop-color="#0066B3"/><stop offset=".354" stop-color="#0066B3"/><stop offset=".688" stop-color="#EE2F53"/><stop offset="1" stop-color="#EE2F53"/></linearGradient></defs></svg>
      </button>
    </div>
  </div>

</template>

<script>
import {mapState} from "vuex";

export default {
  name: "esia",
  data(){
    return {
      canshow:true
    }
  },
  computed: {
    ...mapState({
      valueVuex: state => state.Form.sendData,
      demandState: state => state.instForm.demandState,
      currentStepForm: state => state.instForm.inst_CurrentStepForm
    }),
    calcCanShow(){
      const reqistrationIndex = ['documents','anketa','box','iuConfirm'];
      if (reqistrationIndex.includes(this.currentStepForm.sysName)){
        return this.demandState.ID_ESIA === 0 && Object.keys(this.valueVuex.ESIA).length === 0
      } else {
        return Object.keys(this.valueVuex.ESIA).length === 0;
      }
    }
  },
  methods:{
    async getEsiaToken(code) {
      const params = {
        grant_type: 'authorization_code',
        // грязно, но в нашем варианте деплоя альтернативы не нашел
        redirect_uri: window.location.href.split('?')[0],
        client_id: process.env.VUE_APP_ID_ESIA,
        code,
        client_secret: process.env.VUE_APP_SECRET_ESIA
      }
      try {
        this.$palantir.trackAction(177, `toESIA - POST - ${process.env.VUE_APP_URL_ESIA}/auth/token, ${JSON.stringify(params)}`);
        const { data } = await this.$axios.post(`${process.env.VUE_APP_URL_ESIA}/auth/token`, { ...params })
        this.$palantir.trackAction(177, `fromESIA - getEsiaToken - ${JSON.stringify(data)}`);
        return data.access_token
      } catch(e) {
        console.log(e)
      }
    },
    async getCpg(access_token) {
      try {
        this.$palantir.trackAction(177, `toESIA - POST - ${process.env.VUE_APP_URL_ESIA}/auth/userinfo, ${JSON.stringify({ headers: { 'Authorization': 'Bearer ' + access_token} })}`);
        const { data } = await this.$axios.post(`${process.env.VUE_APP_URL_ESIA}/auth/userinfo `, {}, { headers: { 'Authorization': 'Bearer ' + access_token} })
        this.$palantir.trackAction(177, `fromESIA - getCpg - ${JSON.stringify(data)}`);
        return data.info
      } catch(e) {
        console.log(e)
      }
    },
    async saveDadataAddress(refs) {
      if (!this.valueVuex[refs]) {
        this.$store.commit('saveWorkData', {
          target: refs,
          status: { code: 1, msg: 'обязательное поле, Вы должны выбрать адрес из выпадающего списка', disable: false }
        });
        this.$store.commit('saveErrorShow', { target: refs, value: true });
        return;
      }
      try {
        const { data } = await this.$myApi.suggestResult(
            refs,
            { 'value': this.valueVuex[refs], 'type': refs })
        const suggestions = data?.result?.suggestions;
        if (suggestions && suggestions.length > 0) {
          const suggestion = suggestions[0];
          if (!suggestion?.data?.house) {
            this.$palantir.trackAction(176, this.valueVuex[refs]);
            this.$store.commit('saveWorkData', {
              target: refs,
              status: {
                code: 1,
                msg: 'Адрес не полный, укажите город, улицу и номер дома',
                disable: false
              }
            });
            this.$store.commit('saveErrorShow', {
              target: refs,
              value: true,
            });
            return;
          }
          this.$store.dispatch('saveSendData', {
            target: refs + '_DADATA',
            value: suggestion,
          });
          this.$store.dispatch('saveSendData', {
            target: refs,
            value: suggestion.value
          });
        } else {
          this.$palantir.trackAction(176, this.valueVuex[refs]);
          this.$store.dispatch('saveSendData', {
            target: refs,
            value: ''
          });
          this.$store.commit('saveWorkData', {
            target: refs,
            status: {
              code: 1,
              msg: 'обязательное поле, адрес нужно выбрать из выпадающего списка',
              disable: false
            }
          });
          this.$store.commit('saveErrorShow', { target: refs, value: true });
        }
      } catch (e) {
        console.log(e);
        this.$palantir.trackAction(176, `saveDadataAddress error: ${refs} - ${e}`);
        this.$store.commit('saveWorkData', {
          target: refs,
          status: {
            code: 1,
            msg: 'Не удалось проверить адрес, выберите адрес из выпадающего списка',
            disable: false
          }
        });
        this.$store.commit('saveErrorShow', {
          target: refs,
          value: true,
        });
      }
    },
    gotoEsia() {
      const permissions = [
        'fullname',
        'birthdate',
        'gender',
        'snils',
        'inn',
        'id_doc',
        'birthplace',
        'email',
        'mobile',
        'addresses',
        'electronic_workbook',
      ]
      const params = {
        client_id: process.env.VUE_APP_ID_ESIA,
        response_type: 'code',
        scope: 'openid',
        // грязно, но в нашем варианте деплоя альтернативы не нашел
        redirect_uri: window.location.href.split('?')[0],
        provider: 'cpg_oauth',
        permissions: permissions.join('+'),
        purposes: 'CREDIT',
        sysname: 'CREDIT',
        actions: 'ALL_ACTIONS_TO_DATA',
        expire: 26297460,
        state: window.tmpTestValue
      }
      const querySrting = Object.entries(params).
      map(([key, value]) => `${key}=${value}`).
      join('&');

      this.$palantir.trackAction(177, `toESIA - ${process.env.VUE_APP_URL_ESIA}/auth/authorize?${querySrting}`);
      location.href = encodeURI(`${process.env.VUE_APP_URL_ESIA}/auth/authorize?${querySrting}`)
    }
  },
  mounted() {
    // if(window.partner_id === 404) {
    //   this.canshow = true;
    // }
    //Что-то пошло не так с госуслугами, запишем
    if(this.$route.query.error) {
      this.$palantir.trackAction(175, this.$route.query.error_description);
      this.$router.replace({ query: {} })
    }

    if (this.$route.query.code) {
      this.$palantir.trackAction(177, `fromESIA - ${JSON.stringify(this.$route.fullPath)}`);
      const code = this.$route.query.code;
      this.$router.replace({ query: {} });

      this.getEsiaToken(code).then(access_token => {
        this.getCpg(access_token).then(userInfo => {
          this.$store.dispatch('saveEsiaInfo', userInfo);
          this.saveDadataAddress('RESIDENTIAL_ADDRESS');
          this.saveDadataAddress('REGISTRATION_ADDRESS');
          // this.loadFromEsia = true;
          // this.WsScrollTo({id:'zform'});
          if (this.$route.name === 'registration') {
            this.$store.dispatch('sendEsiaData');
          }

          this.canshow = false;
          this.$emit('scrollEvent');

        })
      })
    }
  }
}
</script>

<style scoped>




.esiaWrap{}
.esiaWrap p{font-weight: 500;text-align: center;margin: var(--font-size-13) auto;font-size: var(--font-size-16)}
.esiaWrap button {display: flex;justify-content: center;align-items: center;background: transparent;}
.esiaWrap button svg{width: 100%;height: 100%;display: block}
@media (min-width: 768px) {
  /*.esiaWrap button img{width: 7rem;padding: 0.3rem 0 0 0.6rem;}*/
}

</style>